import { TXBreadcrumbTemplate } from "../../../types/common/templates.types";

export const X_BREADCRUMB_TEMPLATES: TXBreadcrumbTemplate = {
  "Historique par defaut": {
    template: [
      {
        name: "XBreadcrumb",
        props: {
          all: {},
        },
      },
    ],
  },
};
